// extracted by mini-css-extract-plugin
export default {"loginBlockHeader":"loginBlockHeader-2gF2J","loginBlockHeaderTitle":"loginBlockHeaderTitle-2yRQK"};